import React, { useEffect, useRef, useState } from 'react'
import AllProductsStyle from './AllProducts'
import { Button } from 'antd'
import api, { customFuncsApi } from '../../api'
import { get } from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal } from '../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import moment from 'moment-timezone'
import { isAxiosError } from 'axios'
import _ from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import DeleteTask from '../../components/Modal/DeleteTask'
import AddTask from '../../components/Modal/AddTask'
import PaginationControls from '../../components/PaginationControls'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import { task as TaskStore } from '../../store/slices'
import { BG_COLOR } from '../../constants/colors'

const { RangePicker } = DatePicker

const handleBusinessPartner = _.debounce((searchFunc, value) => {
	searchFunc(value)
}, 1000)

const Task = () => {
	const { status: statusStore } = useSelector((state) => state.task)
	const { getMe, roleAccess } = useSelector((state) => state.main)
	const { setStatus: setStatusStore } = TaskStore.actions

	const isFilterByEmployeeID = roleAccess?.U_MenuTaskFilterByCollector === 'Y'

	const dispatch = useDispatch()

	const errorRef = useRef()
	const deleteRef = useRef()
	const addTask = useRef()

	const dateFormat = 'YYYY-MM-DD'
	const startYear = dayjs().startOf('year').format(dateFormat)
	const today = dayjs().add(1, 'day').format(dateFormat)

	const [isLoadingNotFinished, setIsLoadingNotFinished] = useState(false)
	const [client, setClient] = useState('')
	const [employeeID, setEmployeeID] = useState('')
	const [imeiClient, setImeiClient] = useState('')
	const [notFinished, setNotFinished] = useState([])
	const [currentPageNotFinish, setCurrentPageNotFinish] = useState(0)
	const [clientsData, setClientsData] = useState([])
	const [executors, setExecutors] = useState([])
	const [startPromisedDate, setStartPromisedDate] = useState(startYear)
	const [endPromisedDate, setEndPromisedDate] = useState(today)
	const [status, setStatus] = useState(statusStore || '')

	const handleStartPromisedDateChange = (date) => {
		setStartPromisedDate(date ? date.format(dateFormat) : null)
	}

	const handleEndPromisedDateChange = (date) => {
		setEndPromisedDate(date ? date.format(dateFormat) : null)
	}

	const onRangePromisedDateChange = (dates, dateStrings) => {
		if (dates) {
			const start = dates[0]
			const end = dates[1]

			handleStartPromisedDateChange(start)
			handleEndPromisedDateChange(end)
		} else {
			console.error('Clear in Dashboard Tab1')
		}
	}

	const getNotFinishedDuner = () => {
		setIsLoadingNotFinished(true)
		const url = `xsSql/getTasks`
		const params = {
			cardName: client,
			deadLineStartDate: startPromisedDate,
			deadLineEndDate: endPromisedDate,
			dunnerId: isFilterByEmployeeID
				? get(getMe, 'EmployeeID', '')
				: employeeID,
			hasTask: 'Y',
			isProved: 'Yes',
			imei: imeiClient,
			dunnerStatus: status,
			$skip: currentPageNotFinish,
		}

		customFuncsApi
			.get(url, {
				params,
			})
			.then((res) => {
				const resData = res.data.value
				setNotFinished(resData)

				setIsLoadingNotFinished(false)
			})
			.catch((err) => {
				if (isAxiosError(err)) errorRef.current?.open(get(err, 'message', ''))
				setIsLoadingNotFinished(false)
			})
	}

	const businessPartners = async (value) => {
		api
			.get(`BusinessPartners`, {
				params: {
					$select: 'CardCode, CardName, U_Telephone',
					$filter: `contains(CardName, '${value}') or contains(U_Telephone, '${value}') or contains(CardCode, '${value}') and Frozen eq 'tNO'`,
				},
				headers: {
					Prefer: 'odata.maxpagesize=10',
				},
			})
			.then((res) => {
				setClientsData(JSON.parse(res.data).value || [])
			})
			.catch((err) => {
				if (isAxiosError(err)) errorRef.current?.open(get(err, 'message', ''))
			})
	}

	useEffect(() => {
		getAllGetterMoney()
	}, [])

	const getAllGetterMoney = () => {
		api
			.get(
				`$crossjoin(EmployeesInfo, Departments)?$filter=(Departments/Name eq 'Undiruv' or Departments/Name eq 'Undiruvchi1' or Departments/Name eq 'Undiruvchi3' or Departments/Name eq 'Undiruvchi2') and EmployeesInfo/Department eq Departments/Code&$expand=EmployeesInfo($select=EmployeeID,LastName,FirstName),Departments($select=Name,Code)`,
				{
					headers: {
						Prefer: 'odata.maxpagesize=90000',
					},
				},
			)
			.then((res) => {
				const resData = get(JSON.parse(res.data), 'value', [])
				if (isFilterByEmployeeID) {
					const data = resData.filter(
						(v) => v.EmployeesInfo.EmployeeID === get(getMe, 'EmployeeID', ''),
					)
					setExecutors(data)
				} else setExecutors(resData)
			})
			.catch((err) => {
				errorRef.current?.open(
					get(JSON.parse(err.response.data), 'error.message', ''),
				)
			})
	}

	useEffect(() => {
		getNotFinishedDuner()
	}, [currentPageNotFinish])

	const viewItem = (v) => {
		deleteRef.current?.open(v)
	}

	const newDatasNotFinished = () => {
		if (notFinished.length >= 20) {
			setCurrentPageNotFinish(currentPageNotFinish + 20)
		} else {
			alert('boshqa malumot yoq')
		}
	}

	const oldDataNotFinished = () => {
		if (notFinished.oldPage < 0) {
			alert('boshqa malumot yoq')
		} else {
			setCurrentPageNotFinish(currentPageNotFinish - 20)
		}
	}

	const handleSearch = () => {
		getNotFinishedDuner()
	}

	return (
		<Layout>
			<AllProductsStyle
				style={{
					backgroundColor: BG_COLOR,
				}}
			>
				<div className="container">
					<p className="productTitle">Задачи</p>
					<div className="flex items-center justify-between">
						<div className="flex items-end flex-col sm:flex-row gap-4 my-8">
							<div className="relative">
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									Клиент
								</p>
								<input
									className={
										'border-[1px] border-[#d9d9d9] p-2 rounded-md w-[200px]'
									}
									type="text"
									placeholder="Клиент"
									value={client}
									onChange={(e) => {
										setClient(e.target.value)
										handleBusinessPartner(businessPartners, e.target.value)
									}}
								/>
								{client && (
									<div className="absolute top-16 left-0 bg-white w-full z-10 border-[1px] border-[#d9d9d9] max-h-[300px] overflow-y-scroll">
										{clientsData.map((v, i) => {
											return (
												<div
													key={i}
													className="p-2 border-b cursor-pointer hover:bg-gray-100"
													onClick={() => {
														setClient(v.CardName)
														setClientsData([])
													}}
												>
													{v.CardName}
												</div>
											)
										})}
									</div>
								)}
							</div>
							<div>
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>Имеи</p>
								<input
									className={
										'border-[1px] border-[#d9d9d9"] p-2 rounded-md w-[150px]'
									}
									type="text"
									placeholder="Имеи"
									defaultValue={imeiClient}
									onChange={(v) => {
										setImeiClient(v.target.value)
									}}
								/>
							</div>
							<div>
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									Дедлайн
								</p>
								<RangePicker
									value={[
										startPromisedDate
											? dayjs(startPromisedDate, dateFormat)
											: null,
										endPromisedDate ? dayjs(endPromisedDate, dateFormat) : null,
									]}
									format={dateFormat}
									onChange={onRangePromisedDateChange}
								/>
							</div>
							<div>
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									Приёмщик
								</p>
								<select
									name="executer"
									id="executer"
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-[200px]'
									}
									onChange={(v) => {
										console.log(v.target.value)
										setEmployeeID(v.target.value)
									}}
									value={employeeID}
								>
									<option></option>
									{executors.map((v, i) => {
										return (
											<option
												//  ${get(v, 'EmployeesInfo.LastName', 'Surename')}
												value={`${get(v, 'EmployeesInfo.EmployeeID', '0')}`}
												key={i}
												selected={v.EmployeesInfo.EmployeeID === employeeID}
											>
												{get(v, 'EmployeesInfo.FirstName', 'Name')}{' '}
												{get(v, 'EmployeesInfo.LastName', 'Surename')}
											</option>
										)
									})}
								</select>
							</div>
							<div>
								<p className={'font-medium text-zinc-600 text-sm mb-1'}>
									Статус
								</p>
								<select
									className={
										'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-[150px]'
									}
									onChange={(v) => {
										dispatch(setStatusStore(v.target.value))
										setStatus(v.target.value)
									}}
									value={status}
								>
									<option value=""></option>
									<option value="NotYet">Bajarilmagan</option>
									<option value="Done">Bajarilgan</option>
								</select>
							</div>
							<Button
								className={'bg-[#0A4D68] w-[100px] h-10 text-white rounded-lg '}
								onClick={() => handleSearch()}
								loading={isLoadingNotFinished}
							>
								Поиск
							</Button>
						</div>
						<Button
							className={
								'bg-[#0A4D68] w-[100px] h-10 text-white rounded-lg mt-7'
							}
							onClick={() => addTask.current.open()}
						>
							Добавить
						</Button>
					</div>
					<div className="flex justify-center items-center gap-10 w-full mt-5">
						<div className="w-1/2">
							<div className="flex flex-col gap-4 w-full">
								{isLoadingNotFinished ? (
									<ClipLoader
										loading={true}
										size={75}
										aria-label="Loading Spinner"
										className={'loader'}
										data-testid="loader"
									/>
								) : (
									notFinished.map((v, i) => {
										const deadLine = v.U_DeadLine
											? moment(v.U_DeadLine).format('DD-MM-YYYY HH:mm:ss')
											: ''
										const docDate = moment(v.DocDate).format('DD-MM-YYYY')

										return (
											<div
												key={i}
												onClick={() => viewItem(v)}
												className="bg-white   h-fit border p-5 drop-shadow-xl rounded-3xl cursor-pointer hover:scale-105 transition-all duration-300 ease-in-out hover:bg-gray-100 hover:border-[#0A4D68] hover:border-[0.5px]"
											>
												<div className="flex gap-4">
													<p className="font-bold">Клиент :</p>
													<p className="text-blue-600 font-medium">
														{get(v, 'CardName', '-')}
													</p>
												</div>
												<div className="flex gap-4">
													<p className="font-bold">Приемщик :</p>
													<p className="text-blue-600 font-medium">
														{get(v, 'DunnerName', '-')}
													</p>
												</div>
												<div className="flex gap-4">
													<p className="font-bold">Дата продажи :</p>
													<p className="text-blue-600 font-medium">{docDate}</p>
												</div>
												<div className="flex gap-4">
													<p className="font-bold">Имеи :</p>
													<p className="text-blue-600 font-medium">
														{get(v, 'IntrSerial', '-') || '-'}
													</p>
												</div>
												<div className="flex gap-4">
													<p className="font-bold">Задача :</p>
													<p className="text-blue-600 font-medium">
														{get(v, 'U_Task', '-') || '-'}
													</p>
												</div>
												<div className="flex gap-4">
													<p className="font-bold">Дедлайн :</p>
													<p
														className={`${deadLine === moment().tz('Asia/Tashkent').format('DD-MM-YYYY HH:mm:ss') && get(v, 'U_StatusDunner', '-') === 'NotYet' ? 'text-green-500 font-bold' : deadLine < moment().tz('Asia/Tashkent').format('DD-MM-YYYY HH:mm:ss') && get(v, 'U_StatusDunner', '-') === 'NotYet' ? 'text-red-500 font-bold' : 'text-blue-600 font-medium'}`}
													>
														{deadLine || '-'}
													</p>
												</div>
												<div className="flex gap-4">
													<p className="font-bold">Cтатус :</p>
													<p className="text-blue-600 font-medium">
														{get(v, 'U_StatusDunner', '-') === 'NotYet'
															? 'Bajarilmagan'
															: 'Bajarilgan' || '-'}
													</p>
												</div>
											</div>
										)
									})
								)}
							</div>
							<PaginationControls
								currentPage={currentPageNotFinish}
								onPrevious={oldDataNotFinished}
								onNext={newDatasNotFinished}
								disablePrevious={currentPageNotFinish === 0}
								disableNext={notFinished.length < 10}
							/>
						</div>
					</div>
				</div>
			</AllProductsStyle>
			<>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
				<DeleteTask
					getRef={(r) => {
						deleteRef.current = r
					}}
					onClose={() => {
						getNotFinishedDuner()
					}}
					executer={executors}
				/>

				<AddTask
					getRef={(r) => {
						addTask.current = r
					}}
					onClose={() => {
						getNotFinishedDuner()
					}}
					executer={executors}
				/>
			</>
		</Layout>
	)
}

export default Task
